export const pushDataLayer = (object: Object) => {
  return window.dataLayer.push(object)
}

window.pushDataLayer = pushDataLayer
